var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitEqualsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 11 11",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.335 0C6.74992 4.71604e-06 8.10716 0.561835 9.10766 1.56234C10.1082 2.56284 10.67 3.92007 10.67 5.335C10.67 6.74992 10.1082 8.10716 9.10766 9.10766C8.10716 10.1082 6.74992 10.67 5.335 10.67C3.92007 10.67 2.56284 10.1082 1.56234 9.10766C0.56183 8.10716 0 6.74993 0 5.335C1.17902e-06 3.92007 0.561832 2.56284 1.56234 1.56234C2.56284 0.561837 3.92008 0 5.335 0ZM3.83453 6.00187C3.55831 6.00188 3.33438 6.22581 3.33437 6.50203C3.33438 6.77826 3.5583 7.00219 3.83453 7.00219H6.84003C7.11612 7.00202 7.34018 6.77816 7.34018 6.50203C7.34018 6.2259 7.11612 6.00204 6.84003 6.00187H3.83453ZM3.83453 4.00125C3.55831 4.00125 3.33438 4.22518 3.33437 4.50141C3.33438 4.77763 3.5583 5.00156 3.83453 5.00156H6.84003C7.11612 5.0014 7.34018 4.77753 7.34018 4.50141C7.34018 4.22528 7.11612 4.00141 6.84003 4.00125H3.83453Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitEqualsCircle);
export default __webpack_public_path__ + "static/media/aitEqualsCircle.aa5475ad039147c79832a2a90538fd89.svg";
export { ForwardRef as ReactComponent };